import React, { useEffect } from "react";
import { Container, Grid, Card, CardContent, Typography, Button, Box } from "@mui/material";
import { FaDownload, FaBookOpen } from "react-icons/fa";
import './Ebooks.css';

const resources = [
  {
    title: "Digital Marketing Playbook",
    description: "Unlock powerful strategies to skyrocket your brand's online presence.",
    link: "/ebooks/digital-marketing-essentials.pdf",
  },
  {
    title: "SEO Domination Guide",
    description: "Master Google's algorithm & get your website to the top of search results.",
    link: "/ebooks/seo-best-practices.pdf",
  },
  {
    title: "Viral Social Media Hacks",
    description: "Proven techniques to boost engagement and grow your audience FAST.",
    link: "/ebooks/social-media-growth.pdf",
  },
];

const Ebooks = () => {
  return (
    <Box sx={{ 
      py: 8, 
      backgroundColor: "#fff"  
    }}>
      <Container maxWidth="lg">
        <Box sx={{ 
          textAlign: 'center', 
          mb: 6,
          px: 2
        }}>
          <Typography 
            variant="h3" 
            component="h2" 
            sx={{ 
              fontWeight: 700,
              mb: 2,
              color: "#323232", 
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Unlock Premium Knowledge — For FREE!
          </Typography>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              maxWidth: 700,
              mx: 'auto',
              color: "#323232", 
              fontSize: { xs: '1rem', md: '1.1rem' }
            }}
          >
            Elevate your skills with our expert-crafted e-books.
          </Typography>

          <Typography 
            variant="subtitle1" 
            sx={{ 
              maxWidth: 700,
              mx: 'auto',
              color: "#323232",  
              fontSize: { xs: '1rem', md: '1.1rem' }
            }}
          >
            No cost. No catch. Just pure value.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {resources.map((resource, index) => (
            <Grid 
              item 
              xs={12} 
              sm={6} 
              md={4} 
              key={index}
            >
              <Card sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease-in-out',
                backgroundColor:"#ffffff", 
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 28px rgba(0,0,0,0.12)'
                }
              }}>
                <CardContent sx={{ 
                  flexGrow: 1,
                  p: 4,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                  <Box sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: "#ff650033", 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 3,
                    color: "#ff6500",
                  }}>
                    <FaBookOpen size={32} />
                  </Box>
                  
                  <Typography 
                    variant="h5" 
                    component="h3" 
                    sx={{ 
                      fontWeight: 600,
                      mb: 2,
                      color: "#323232",
                    }}
                  >
                    {resource.title}
                  </Typography>
                  
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      mb: 3,
                      color: "#323232",
                      flexGrow: 1
                    }}
                  >
                    {resource.description}
                  </Typography>
                  
                  <Button
                    variant="contained"
                    href={resource.link}
                    download
                    startIcon={<FaDownload />}
                    fullWidth
                    sx={{
                      py: 1.5,
                      borderRadius: 1,
                      backgroundColor: '#ff6500',
                      fontWeight: 600,
                      textTransform: 'none',
                      fontSize: '1rem',
                      '&:hover': {
                        backgroundColor: "#323232", 
                      }
                    }}
                  >
                    Download Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Ebooks;